module.exports = __webpack_public_path__ + "static/media/AndroidStudio.8e5e05aa.png";